/**
 * Mounts the embedded rep surface and injects the design system.
 *
 * Same two style blocks and same reasoning as the prospect surface: `tokens` is what a customer overrides under
 * D-01 and `surfaceStyles` is what the primitives depend on, so keeping them separate makes a retheme a third
 * block appended after these two, with no `!important` and no specificity fight.
 *
 * Injected here rather than imported as CSS because `@iqz-ddds/components` is consumed as source with no build
 * step of its own, so it makes no bundler assumptions.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { fontFaces, surfaceStyles, tokens } from '@iqz-ddds/components';
import { App } from './App';

const style = document.createElement('style');
style.textContent = `${fontFaces}\n${tokens}\n${surfaceStyles}`;
document.head.appendChild(style);

const root = document.getElementById('root');
if (root === null) throw new Error('Root element #root is missing from index.html.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
